import { FC } from "react";
import classNames from "classnames";

import { IconType } from "@types";

import { Icon } from "components/atoms/Icon/Icon";

import { IconRecord } from "@graphql/types/graphql";
import s from "./AccordionItem.module.scss";

interface Props {
  id: string;
  icon?: IconRecord[];
  title: string;
  children: React.ReactNode;
  timeline?: boolean;
  isOpen?: boolean;
}

export const AccordionItem: FC<Props> = ({
  id,
  icon,
  title,
  children,
  timeline,
  isOpen = false,
}) => {
  return (
    <details
      open={isOpen}
      className={classNames(s.Details, {
        [s.IsTimeline]: timeline,
      })}
    >
      <summary
        className={s.Summary}
        aria-controls={id}
      >
        <div className={s.TitleContainer}>
          <div className={s.TitleIconContainer}>
            {icon && icon.length > 0 && (
              <div className={s.Icon}>
                <Icon name={icon[0].iconName} size="m" color="blue" background />
              </div>
            )}
            <h3 className={s.Title} itemProp="name">
              {title}
            </h3>
          </div>
          <div className={s.Toggle}>
            <Icon name={IconType.CaretFilledDown} size="xs" />
          </div>
        </div>
      </summary>
      <div id={id} className={classNames("prose", s.Content)}>
        {children}
      </div>
    </details>
  );
};
